import hcOffcanvasNav from "hc-offcanvas-nav";

/**
 * More configurations can be found at https://github.com/somewebmedia/hc-offcanvas-nav
 * @param {string} menuContainerCssClass - The CSS class of the menu container
 * @param {string} toggleBtnCssClass - The CSS class of the toggle button
 */
function mobileMenu(menuContainerCssClass, toggleBtnCssClass) {
	new hcOffcanvasNav(menuContainerCssClass, {
		disableAt: 996,
		customToggle: toggleBtnCssClass,
		position: 'left',
		bodyInsert: 'append'
	});
}

export default mobileMenu;